// src/components/Nodes/CommonNodeModal.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimes, FaCopy } from 'react-icons/fa';

const CommonNodeModal = ({ isOpen, onClose, nodeData, onSave, workflowId }) => {
  // const [formData, setFormData] = useState(nodeData.data || {});
  //const [inputFields, setInputFields] = useState(nodeData.parameters?.values || []);

  const navigate = useNavigate();

  const handleCustomizeTemplate = () => {
    //onSave({ });
    //navigate('/portalBuilder/create');
    console.log(nodeData.id, workflowId);
    navigate(`/portalBuilder/create`, {
      state: {
        workflowId: workflowId,
        nodeId: nodeData.id,
        //workflowName: 'newWorkflowName',
      },
    });
    onClose();
  };

  return isOpen ? (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal}>
        <div style={modalStyles.header}>
          <h2>{nodeData.data.label}</h2>
          <FaTimes onClick={onClose} style={modalStyles.closeIcon} />
        </div>

        <div style={modalStyles.actions}>
          {/* <button onClick={handleCustomizeTemplate} style={modalStyles.saveButton}>
            Customize Template 
          </button> */}
        </div>
      </div>
    </div>
  ) : null;
};

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    width: '600px',
    padding: '20px',
    boxSizing: 'border-box',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    maxHeight: '80vh',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    position: 'relative',
  },
  closeIcon: {
    cursor: 'pointer',
    fontSize: '18px',
    color: '#333',
    position: 'absolute',
    top: '-10px',
    right: '-10px',
  },
  scrollableContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    overflowY: 'auto',
    flexGrow: 1,
    paddingRight: '10px',
  },
  label: {
    fontWeight: 'bold',
    marginBottom: '8px',
  },
  input: {
    width: '100%',
    padding: '8px',
    marginBottom: '12px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },
  urlWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  copyIcon: {
    cursor: 'pointer',
    fontSize: '18px',
    color: '#666',
    marginLeft: '8px',
  },
  inputFieldsWrapper: {
    marginTop: '20px',
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  fieldSelect: {
    flexGrow: 1,
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginRight: '8px',
  },
  removeButton: {
    padding: '6px 12px',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#d9534f',
    color: '#fff',
    cursor: 'pointer',
  },
  addButton: {
    padding: '8px 16px',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#5bc0de',
    color: '#fff',
    cursor: 'pointer',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '20px',
  },
  saveButton: {
    padding: '10px 16px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    backgroundColor: 'var(--primary-color)',
    color: '#fff',
    textAlign: 'center',
  },
};

export default CommonNodeModal;
